import React from 'react';
import { useTranslation } from 'react-i18next';

import { UserStartupsList } from 'core/components/user';
import { iframePush } from 'core/iframe';
import { CONFIG } from 'config';
import { RHP } from 'providers';

import * as Page from 'components/page';

export const StartupIndex = props => {
    const { t } = useTranslation('ranking');
    const { vars } = props.useStartup;
    const { startups, startupId } = vars;

    if (startups.length === 0) {
        // RHP.push('/startup/register');
        iframePush(`${CONFIG.appLinks.startup}`, '/startup')();
        return null;
    }

    if (startups.length === 1) {
        // RHP.push('/startup/register');
        RHP.push(`startup/${startups[0]._id}`);
        return null;
    }

    const handleClick = startup => {
        RHP.push(`startup/${startup._id}`);
    };

    return (
        <Page.Page name="StartupIndex" loading={!startups.length} back="/home">
            <Page.Title>{props.t('StartupIndex.title')}</Page.Title>
            <Page.Descr>{props.t('StartupIndex.descr')}</Page.Descr>

            <UserStartupsList
                data={startups.map(startup => ({
                    ...startup,
                    name: startupId === startup._id ? t('loadingStartupData') : startup.name,
                    onClick: () => handleClick(startup),
                }))}
            />
        </Page.Page>
    );
};

export default StartupIndex;
